import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { BodyText } from '@calendly/ui/components/typography';
import { colorSurfaceDisabled } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetUserQuery } from 'common';
import { useTrack } from 'hooks/analytics_events';
import { useGetPurchaseFulfillmentsByEventUuidsQuery } from 'shared/api/commerce/graphql_api';
import { PackageIcon } from './package_icon';
import { getSessionSummary, getTransactionsUrl } from '../invitees_widget/meeting_package_fulfillment_utils';
import { WidgetContainer } from '../widget_container';
const getMutedColor = (hexColor, opacity = 0.1) => {
  try {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const mutedR = Math.round(r * opacity + 255 * (1 - opacity));
    const mutedG = Math.round(g * opacity + 255 * (1 - opacity));
    const mutedB = Math.round(b * opacity + 255 * (1 - opacity));
    return `#${mutedR.toString(16).padStart(2, '0')}${mutedG.toString(16).padStart(2, '0')}${mutedB.toString(16).padStart(2, '0')}`;
  } catch {
    return colorSurfaceDisabled;
  }
};
const cardCss = "c1irmhcb";
const Card = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardCss, props.className)} />;
});
const iconContainerCss = "i1na9luv";
const IconContainer = forwardRef(({
  bgColor,
  ...props
}, ref) => <div ref={ref} {...props} className={classNames(iconContainerCss, props.className)} style={{
  backgroundColor: bgColor
}} />);
const textContentCss = "t13yya74";
const TextContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContentCss, props.className)} />;
});
const packageNameCss = "p197ur2u";
export const MeetingPackageWidget = ({
  event
}) => {
  const history = useHistory();
  const track = useTrack();
  const {
    data: currentUser
  } = useGetUserQuery();
  const ownerUuid = currentUser?.uuid;
  const isGroup = event?.eventType?.kind === 'group';
  const eventUuids = useMemo(() => event?.uuid ? [event.uuid] : [], [event?.uuid]);
  const {
    data
  } = useGetPurchaseFulfillmentsByEventUuidsQuery({
    eventUuids,
    ownerUuid
  }, {
    skip: eventUuids.length === 0 || !ownerUuid || isGroup
  });
  if (isGroup) return null;
  const fulfillment = data?.purchaseFulfillmentsByEventUuids?.collection?.[0];
  if (!fulfillment) return null;
  const {
    purchasedPackage
  } = fulfillment;
  if (!purchasedPackage) return null;
  const packageName = fulfillment.package?.name ?? purchasedPackage.name;
  const sessionSummary = getSessionSummary(purchasedPackage.purchasedPackageItems);
  const transactionsUrl = getTransactionsUrl(purchasedPackage);
  const eventTypeColor = event?.eventType?.color || event?.event_type?.color || '#0069ff';
  return <WidgetContainer title={I18n.t('publisher.meetings.meeting_package.title')}>
      <Card>
        <IconContainer bgColor={getMutedColor(eventTypeColor)}>
          <PackageIcon color={eventTypeColor} size={20} />
        </IconContainer>
        <TextContent>
          <BodyText weight="bold" className={packageNameCss}>{packageName}</BodyText>
          {sessionSummary && <BodyText size="medium" color="muted">
              {I18n.t('publisher.meetings.meeting_package.sessions_progress', {
            fulfilled: sessionSummary.fulfilledUnits,
            total: sessionSummary.totalUnits
          })}
            </BodyText>}
        </TextContent>
        {transactionsUrl && <Button decoration="secondary-outline" size="small" onClick={() => {
        track({
          name: 'Meeting Interaction',
          properties: {
            action: 'view_meetings_package',
            location: 'meetings_page_right_rail'
          }
        });
        history.push(transactionsUrl);
      }}>
            {I18n.t('publisher.action.view')}
          </Button>}
      </Card>
    </WidgetContainer>;
};

require("./meeting_package_widget.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_package_widget.js");